document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.matchMedia('(max-width:1024px)');

    const initSwiper = () => {
        document.querySelectorAll('.methodology-details .swiper-container').forEach(el => {
            el.style.height = 'calc(100% - 32px)';
            el.style.paddingRight = isMobile.matches ? '0' : '32px';

            const swiperSlideQuantity = el.querySelectorAll('.swiper-slide').length;
            const paginationEl = el.closest('.methodology-details').querySelector('.swiper-pagination');

            if (paginationEl) {
                if (isMobile.matches) {
                    paginationEl.style.display = 'none';
                } else {
                    paginationEl.style.display = swiperSlideQuantity > 3 ? '' : 'none';
                }
            }

        });
    };

    const fadeContent = (el, callback) => {
        el.style.transition = 'opacity 0.5s ease';
        el.style.opacity = 0;
        setTimeout(() => {
            callback();
            el.style.opacity = 1;
        }, 500);
    };

    const updateInfo = (slideEl, info) => {
        if (!slideEl) return;
        const titleEl = slideEl.querySelector('.methodology-details__label');
        const imageEl = slideEl.querySelector('.methodology-details__image');
        if (!titleEl || !imageEl) return;

        const infoTitle = info.querySelector('.methodology-details__info-title');
        const infoDesc = info.querySelector('.methodology-details__info-description');

        fadeContent(infoTitle, () => infoTitle.textContent = titleEl.textContent);
        fadeContent(infoDesc, () => infoDesc.innerHTML = imageEl.dataset.description);
    };

    const initializeSlides = wrapper => {
        const slides = [...wrapper.children];
        slides.forEach((s, idx) => {
            s.style.flexBasis = idx === 0 ? '400px' : '135px';
            s.style.zIndex = idx === 0 ? '1' : '0';
            s.style.transition = 'transform 1s ease, flex-basis 1s ease';
        });
    };

    const animateClick = (clicked, wrapper, info) => {
        const slides = [...wrapper.children];
        slides.forEach(s => s.dataset.prevLeft = s.getBoundingClientRect().left);

        wrapper.insertBefore(clicked, wrapper.firstChild);
        wrapper.style.transition = 'transform 1s ease';
        wrapper.style.transform = 'translateX(0)';


        void wrapper.offsetWidth;

        slides.forEach(s => {
            const delta = s.dataset.prevLeft - s.getBoundingClientRect().left;
            s.style.transition = 'none';
            s.style.transform = `translateX(${delta}px)`;
            s.style.flexBasis = getComputedStyle(s).flexBasis;
        });

        void wrapper.offsetWidth;

        slides.forEach(s => {
            s.style.transition = 'transform 1s ease, flex-basis 1s ease';
            s.style.transform = 'translateX(0)';
            s.style.flexBasis = s === clicked ? '400px' : '135px';
            s.style.zIndex = s === clicked ? '1' : '0';
        });

        updateInfo(clicked, info);
    };

    const setupDesktop = (content, swiperWrapper, info) => {
        initializeSlides(swiperWrapper);
        updateInfo(swiperWrapper.querySelector('.swiper-slide'), info);

        content.querySelectorAll('.methodology-details__item').forEach(item => {
            item.addEventListener('click', () => {
                const clicked = item.closest('.swiper-slide');
                if (!clicked) return;
                animateClick(clicked, swiperWrapper, info);
            });
        });
    };

    const setupMobile = (swiperEl, info) => {
        const swiperInstance = swiperEl.swiper;
        if (!swiperInstance) return;
        updateInfo(swiperInstance.slides[swiperInstance.activeIndex], info);
        swiperInstance.on('slideChange', () => {
            updateInfo(swiperInstance.slides[swiperInstance.activeIndex], info);
        });
    };

    document.querySelectorAll('.methodology-details__content').forEach(content => {
        const swiperEl = content.querySelector('.swiper-container');
        const swiperWrapper = swiperEl?.querySelector('.swiper-wrapper');
        const info = content.querySelector('.methodology-details__info');
        if (!swiperEl || !swiperWrapper || !info) return;


        initSwiper();

        if (!isMobile.matches) setupDesktop(content, swiperWrapper, info);
        else setupMobile(swiperEl, info);
    });
});
